import { RelayDto, SpeakerDto } from '@/lib/api/types.gen';
import { AddressDto } from './common-types';

export interface DatalayerAssetDto {
  id: string;
  name: string;
  externalId: string;
  groupId?: string;
  companyId: string;
  projectId: string;
  hasHardware: boolean;
  groupName?: string;
  groupType?: AssetType;
  zoneId?: string;
  siteId?: string;
  location: string;
  lastSensorUpdate?: string;
  deletedAt?: string;
  videoProcessorConfigs: AssetVideoConfigDto[];
  phoneNumber: string;
  address: AddressDto;
  serialNumber: string;
  components: AssetComponentDto[];
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
}

export interface DatalayerAssetExtendedDto extends DatalayerAssetDto {
  nvrId?: string;
  integrationId?: string;
}

export enum AssetType {
  Person,
  Equipment,
  Plant,
  Vehicle,
}

export interface AssetComponentDto {
  id: string;
  type: ComponentType;
  userName: string;
}

export enum ComponentType {
  MqttRelay,
  Camera,
  Router,
  Siren,
}

export interface AssetVideoConfigDto {
  videoProcessor: EnumVideoProcessor;
  videoProcessorId: string;
  name: string;
  description?: string;
  externalId?: string;
  aiPrimer: string;
  notes: string;
  id: string;
  activationZoneWkt: string;
  nvrId: string;
  nvrDeviceName: string;
  smtpRtsp?: SmtpRtspDto;
  smtpParsingRule: SmtpParsingRuleDto;
}

export interface SmtpParsingRuleDto {
  id: string;
  name: string;
  datePrefix: string;
  dateRegex: string;
  dateFormat: string;
  channelPrefix: string;
  channelRegex: string;
  eventTypePrefix: string;
  eventTypeRegex: string;
  eventParsingRules: MonitoringEventParsingRuleDto[];
}

export interface MonitoringEventParsingRuleDto {
  monitoringEventPrefix: string;
  monitoringEventValueType: MonitoringEventValueType;
  id: string;
}

export enum MonitoringEventValueType {
  SnapshotImage,
  PreviewVideo,
  PersonCount,
  PersonSeen,
  VehicleSeen,
  Unknown,
  AnimalSeen,
  PreviewVideoLink,
  PreviewVideoMp4,
}

export interface AssetVideoProcessorDto {
  videoProcessor: EnumVideoProcessor;
  assetName: string;
  description?: string;
  nvrDeviceName?: string;
  assetSerial: string;
  assetId: string;
  videoProcessorId: string;
  videoProcessorConfigId: string;
}

// export enum EnumVideoProcessor {
//     UmboCv = 1,
//     ThreeDEye = 2,
//     Smtp = 3,
//     Milestone = 4,
//     Camect = 5,
//     NxWitness = 6,
//     HikVisionNvr = 7,
//     DahuaCamera = 8,
//     OpenEye = 9,
//     IntegrationHub = 10
// }

export enum EnumVideoProcessor {
  UmboCv = 'UmboCv',
  ThreeDEye = 'ThreeDEye',
  Smtp = 'Smtp',
  Milestone = 'Milestone',
  Camect = 'Camect',
  NxWitness = 'NxWitness',
  HikVisionNvr = 'HikVisionNvr',
  DahuaCamera = 'DahuaCamera',
  OpenEye = 'OpenEye',
  IntegrationHub = 'IntegrationHub',
}

export const videoProcessorToDisplay = {
  [EnumVideoProcessor.UmboCv]: 'Umbo Cv',
  [EnumVideoProcessor.ThreeDEye]: '3DEye',
  [EnumVideoProcessor.Smtp]: 'SMTP',
  [EnumVideoProcessor.Milestone]: 'Milestone',
  [EnumVideoProcessor.Camect]: 'Camect',
  [EnumVideoProcessor.NxWitness]: 'NxWitness',
  [EnumVideoProcessor.HikVisionNvr]: 'HikVision',
  [EnumVideoProcessor.DahuaCamera]: 'DahuaCamera',
  [EnumVideoProcessor.OpenEye]: 'OpenEye',
  [EnumVideoProcessor.IntegrationHub]: 'iHub',
};

export interface ProjectMonitoringDto {
  monitoringCompanyName?: string;
  monitoringCompanyId?: string;
  externalId?: string;
  order?: number;
}

export interface SmtpRtspDto {
  url: string;
  timeZone: string;
  timeFormat: string;
}
